<script>
import gql from "graphql-tag";
import { tournamentMatchStartedFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";
import { MatchTools, NA_VENUE } from "@/js/helper";

export default {
  name: "MatchStartDialog",
  extends: BaseDialog,
  props: { tournament: Object, match: Object },
  data: function() {
    return {
      venue: {
        label: "Venue for the match",
        value: NA_VENUE
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.venue];
      }
    },
    title: {
      get() {
        return `Start match - ${this.match.name}`;
      }
    },
    instructions: {
      get() {
        return MatchTools.competitorsDescription(this.match);
      }
    }
  },
  methods: {
    copyValues() {
      this.venue.options = MatchTools.venueOptions(this.tournament);
    },

    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $matchId: ID!, $venueId: ID) {
              startMatch(
                tournamentId: $tournamentId
                matchId: $matchId
                venueId: $venueId
              ) {
                ...TournamentMatchStarted
              }
            }
            ${tournamentMatchStartedFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            matchId: this.match.id,
            venueId:
              this.venue.value === NA_VENUE ? undefined : this.venue.value
          }
          /*
        update: (_, { data: { signinPayload } }) => {
          this.$store.commit("setCurrentUser", signinPayload);
		}
		*/
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            `Match ${this.match.name} is set to start`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to start the match");
        });
    }
  },
  watch: {
    tournament: {
      handler(val) {
        this.copyValues();
      },
      deep: true
    }
  },
  created() {
    this.copyValues();
  }
};
</script>


// WEBPACK FOOTER //
// matchStartDialog.vue?958a01a2